import React, { useEffect, useState } from 'react';
import { Skeleton } from '@mui/material';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { StyledPeriodSwitcher } from '../index.style';

const LABELS = [
  { vi: 'Ngày', enSingular: 'Day', enPlural: 'Days', key: 'days' },
  { vi: 'Giờ', enSingular: 'Hour', enPlural: 'Hours', key: 'hours' },
  { vi: 'Phút', enSingular: 'Minute', enPlural: 'Minutes', key: 'minutes' },
  { vi: 'Giây', enSingular: 'Second', enPlural: 'Seconds', key: 'seconds' },
];

export const getLabel = (value, viLabel, enSingular, enPlural, lang) => {
  if (lang === 'vi') return viLabel;
  return value === 1 ? enSingular : enPlural;
};

export const getTimeLeft = (endDate) => {
  if (!endDate) {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    };
  }
  const now = moment();
  const end = moment(endDate);
  const duration = moment.duration(end.diff(now));
  const totalSeconds = duration.asSeconds();
  if (totalSeconds <= 0) {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    };
  }
  return {
    days: Math.max(0, Math.floor(duration.asDays())),
    hours: duration.hours(),
    minutes: duration.minutes(),
    seconds: duration.seconds(),
  };
};

const PeriodSwitcher = ({ endDate, startDate, isLoading, commingSoon }) => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const [timeLeft, setTimeLeft] = useState(
    getTimeLeft(commingSoon ? startDate : endDate),
  );

  useEffect(() => {
    const timer = setInterval(
      () => setTimeLeft(getTimeLeft(commingSoon ? startDate : endDate)),
      1000,
    );
    return () => clearInterval(timer);
  }, [commingSoon, startDate, endDate]);

  const isExpired = endDate ? moment().isAfter(moment(endDate)) : false;

  if (isExpired) {
    return (
      <StyledPeriodSwitcher style={{ gap: 4 }}>
        <Typography
          variant="body-14-regular"
          color={COLOR.textRejected}
          style={{ display: 'flex', alignItems: 'center', gap: 4 }}
          className="text-period-switcher"
        >
          {t('eventPeriod')}
        </Typography>{' '}
        <Typography
          variant="body-16-semibold"
          color={COLOR.textRejected}
          style={{ display: 'flex', alignItems: 'center', gap: 4 }}
          className="text-period-switcher"
        >
          {moment(startDate).format('DD/MM/YYYY')} -{' '}
          {moment(endDate).format('DD/MM/YYYY')}
        </Typography>
        <Typography
          variant="body-16-regular"
          color={COLOR.textRejected}
          style={{ display: 'flex', alignItems: 'center', gap: 4 }}
          className="text-period-switcher"
        >
          {t('eventPeriodEnded')}
        </Typography>
      </StyledPeriodSwitcher>
    );
  }

  return (
    <>
      <StyledPeriodSwitcher>
        <Typography
          variant="body-14-regular"
          color={COLOR.descriptionUpload}
          style={{ display: 'flex', alignItems: 'center', gap: 4 }}
          className="text-period-switcher"
        >
          {commingSoon ? t('eventStart') : t('eventEndsIn')}
        </Typography>
        {LABELS.map(({ vi, enSingular, enPlural, key }) => (
          <React.Fragment key={key}>
            <Typography
              variant="body-16-semibold"
              color={COLOR.descriptionGray}
              style={{ margin: '0 4px' }}
              className="text-period-switcher"
            >
              {isLoading ? (
                <Skeleton variant="text" width={30} height={30} />
              ) : (
                String(timeLeft[key]).padStart(2, '0')
              )}
            </Typography>
            <Typography
              variant="body-14-regular"
              color={COLOR.descriptionUpload}
              style={{ display: 'flex', alignItems: 'center', gap: 4 }}
              className="text-period-switcher"
            >
              {getLabel(timeLeft[key], vi, enSingular, enPlural, lang)}
            </Typography>
          </React.Fragment>
        ))}
      </StyledPeriodSwitcher>
      {!commingSoon && (
        <Typography
          variant="body-14-regular"
          color={COLOR.descriptionUpload}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          className="text-period-switcher"
        >
          {t('rewardsWillBeDistributedAfterTheEventEnds')}
        </Typography>
      )}
    </>
  );
};

export default PeriodSwitcher;
